<template>


  <div class="xinzi_text">
    <div class="menu-voice">
      <div class="audio-ctrl-btn pointer" @click="play">播放</div>
      <div class="audio-ctrl-btn pointer" @click="stop">停止</div>
      <div class="audio-ctrl-btn pointer" @click="cancel">取消</div>
    </div>
    <div class="center-voice" placeholder="请输入您要合成的文本" v-html="txt"></div>
  </div>
</template>

<script >
// import {downloadPCM, downloadWAV} from '@/assets/js/download.js'
// import CryptoJS from 'crypto-js'
// import Enc from 'enc'
// // import TransWorker from '@/assets/js/transcode.worker.js'
// import VConsole from 'vconsole'
// import { Base64 } from 'js-base64'
// import '@/assets/css/index.css'

// let transWorker = new TransWorker()
//APPID，APISecret，APIKey在控制台-我的应用-语音合成（流式版）页面获取
const APPID = 'f362a7c6'
const API_SECRET = 'OWY3ZGNhMjczNzI2ZGMxNjQwMGJmMTZh'
const API_KEY = '778f2cce7713cb3c66cb74c11c30f8a2'
const synth = window.speechSynthesis;
const msg = new SpeechSynthesisUtterance();
import {get_content} from '@/api/api.js'

let nav = $(".menu-voice"); //得到导航对象
let win = $(window); //得到窗口对象
let sc = $(document); //得到document文档对象。
win.scroll(function() {
  if(sc.scrollTop() >= 0) {
    // console.log(sc.scrollTop(),"===");
    $(".menu-voice").addClass("fixednav");
    // console.log(nav.addClass("fixednav"),'999');
  } else {
    $(".menu-voice").removeClass("fixednav");
  }
})
export default {
  name: 'voice',
  data () {
    return {
      id:'',//详情id
      company_id:'',//电子书ID
      list:[],//电子书列表
      per_page:10,
      page:1,
      total:'',
    }
  },
  mounted(){
  let that=this
    if(this.$route.query.keys)
    this.key=this.$route.query.keys
    // this.fiction()
    this.getBook()
    this.cancel()
  },
  methods:{
     stop1() {
       let that=this
       console.log(that.txt,777)
      var msg = new SpeechSynthesisUtterance(that.txt);
      //msg.rate = 4 播放语速
      //msg.pitch = 10 音调高低
      //msg.text = "播放文本"
      //msg.volume = 0.5 播放音量
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(msg);
    },
     stop2() {
      window.speechSynthesis.cancel();
    },

    getBook(){
      let data = {
        keys: this.key
      }
      get_content(data).then((res) => {
        if (res.code == 1) {
          let key=this.key
          this.list = res.data[key]
          this.txt=this.list.cn_content
        }
      }).catch(err => {
        console.log(err)
      })
    },
    play(){
      var aa =document.getElementsByClassName('center-voice')[0].innerText
      // console.log("play=>",aa);
      var msg = new SpeechSynthesisUtterance(aa);
      // var msg = new SpeechSynthesisUtterance(that.txt);
      //msg.rate = 4 播放语速
      //msg.pitch = 10 音调高低
      //msg.text = "播放文本"
      //msg.volume = 0.5 播放音量
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(msg);
      // var msg =new SpeechSynthesisUtterance(this.txt);
      // window.speechSynthesis.pause(msg);
    },
    stop(){
      var aa =document.getElementsByClassName('center-voice')[0].innerText
      const msg =new SpeechSynthesisUtterance(aa);
      window.speechSynthesis.speak(msg);
    },
    cancel(){
      window.speechSynthesis.cancel();
    }
  }
}
</script>

<style>
.xinzi_text{
  width: 100%;
  height: 935px;
}
.center-voice{
  width: 1400px;
}
.audio-ctrl-btn{
  border: 1px solid;
  display: inline-block;
  padding: 5px 10px;
  border-radius: 4px;
  margin: 5px;
}
.center-voice{
  text-align: center;
}
.fixednav{position: fixed;top:0px;left:12.5%px;max-width:1400px;z-index:20;width: 100%; background: #fff;padding: 10px 0px;}
</style>
